import type { CalendarSystem, Lang } from '@calendar/shared';
const keys = ['spring','summer','autumn','winter'];
const credits = [
  ['Bam_(2000)_17.jpg','LBM1948'],['010213-Bam-IMG_0316-2.jpg','Safa.daneshvar'],
  ['16-09_Arg_Bam_C-GRAZ.jpg','Christophe GRAZ'],['010213-Kerman-IMG_0323-2.jpg','Safa.daneshvar'],
];
export function SeasonBanner({season,lang,calendar}: {season:number;lang:Lang;calendar:CalendarSystem}) {
  // The season index is resolved against the Iranian year for every calendar on
  // screen, so the same four names are correct whether the view is Jalali,
  // Gregorian or Hijri. The calendar is kept in the signature so the banner can
  // pick the year's layout when it needs it.
  void calendar;
  const label = (lang==='fa' ? ['بهار','تابستان','پاییز','زمستان'] : ['Spring','Summer','Autumn','Winter'])[season];
  return <div className={`season-banner season-banner--${keys[season]}`}>
    <img src={`./bam/${keys[season]}.jpg`} alt={lang==='fa'?'ارگ و چشم‌انداز شهر بم، استان کرمان':'Bam citadel and landscape, Kerman, Iran'} loading="lazy" />
    <div><span>{lang==='fa'?'بم، شهر نخل و آفتاب':'Bam · palms and sunshine'}</span><h2>{label}</h2></div>
    <a href={`https://commons.wikimedia.org/wiki/File:${credits[season]![0]}`} target="_blank" rel="noreferrer">{credits[season]![1]} · CC BY-SA 4.0{season===0?' · 2000':''}</a>
  </div>;
}
